<template>

  <v-container fluid>
    
    <!-- 추가/수정 팝업 -->
    <v-row>
      <v-dialog persistent scrollable overlay-color="#00000040" v-model="dialog" @keydown.esc="close" max-width="750px">
        <v-card class="dialog_round pa-10">

          <v-row dense align="center">
            <v-col cols="11" md="11" sm="11" xs="11">
              <span class="dialog_title">{{ dialogTitle }}</span>
            </v-col>
            <v-col cols="1" md="1" sm="1" xs="1">
              <v-btn class="dialog_close_btn mr-1" outlined rounded fab x-small @click="close"><v-icon>mdi-close</v-icon></v-btn>
            </v-col>
          </v-row>

          <v-row dense justify="center">
            <v-col cols="12" md="12" sm="12" xs="12">
              <div style="background:#4e6ef7;height:2px;" />
            </v-col>
          </v-row>

          <v-card-text>
            <v-container>
              <v-row  dense class="ma-3">
                  <v-text-field outlined dense
                   v-model="editedItem.NAME" :label="$t('eventlist_col2')" hide-details></v-text-field>
              </v-row>
              <v-row class="mt-5" dense>
                <v-col md="6" cols="12" align="end">
                  <label style="margin:10px; width:80px;text-align:right">{{$t("eventlist_col8")}}</label>
                  <datetime input-style="margin-left:10px; width:120px; border-bottom:1px solid gray; text-align:left;" 
                            type="datetime" format="yyyy-MM-dd HH:mm" :title="$t('eventlist_col8')" value-zone="Asia/Seoul"
                            v-model="editedItem.EVENT_START" />
                </v-col>
                <v-col md="6" cols="12" align="start">
                  <label style="margin:10px; width:80px;text-align:right">{{$t("eventlist_col9")}}</label>
                  <datetime input-style="margin-left:10px; width:120px; border-bottom:1px solid gray; text-align:left;" 
                            type="datetime" format="yyyy-MM-dd HH:mm" :title="$t('eventlist_col9')"  value-zone="Asia/Seoul"
                            v-model="editedItem.EVENT_END" />
                </v-col>
              </v-row>

              <!-- 
              <v-row dense>
                <v-col md="12" sm="12" xs="12">
                  <v-select v-model="editedItem.PART_TYPE" :items="PARTLIST" label="참여기업" item-text="name" item-value="value"/>
                </v-col>
              </v-row>

              <v-row dense>
                <v-col md="12" sm="12" xs="12">
                  <v-select v-model="editedItem.APP_TYPE" :items="APPTYPELIST" label="앱노출" item-text="name" item-value="value"/>
                </v-col>
              </v-row>
              -->

              <v-row dense class="mt-3">
                <v-col cols="12" class="pa-0">
                  <label style="font-weight:bold;font-size:16px">{{$t("eventlist_label1")}}</label>
                </v-col>
                <v-col cols="6" md="4">
                  <!-- WelCome화면에 참여기업수 표시 유무 -->
                  <v-tooltip bottom>
                    <template v-slot:activator="{ on }">
                      <v-checkbox dense :label="$t('eventlist_col6')" v-on="on" v-model="editedItem.PART_TYPE" hide-details/>
                    </template>
                    <span>{{$t("eventlist_label2")}}</span>
                  </v-tooltip>
                </v-col>
                <v-col cols="6" md="4">
                  <v-tooltip bottom>
                    <template v-slot:activator="{ on }">
                      <v-checkbox dense :label="$t('eventlist_col7')" v-on="on" v-model="editedItem.APP_TYPE" hide-details/>
                    </template>
                    <span>{{$t("eventlist_label3")}}</span>
                  </v-tooltip>
                </v-col>
                <v-col cols="6" md="4">
                  <v-tooltip bottom>
                    <template v-slot:activator="{ on }">
                      <v-checkbox dense :label="$t('eventlist_label4')" v-on="on" v-model="editedItem.PAY_TYPE" hide-details/>
                    </template>
                    <span>{{$t("eventlist_label5")}}</span>
                  </v-tooltip>
                </v-col>
                <v-col cols="6" md="4">
                  <v-tooltip bottom>
                    <template v-slot:activator="{ on }">
                      <v-checkbox dense :label="$t('eventlist_label6')" v-on="on" v-model="editedItem.COL_TYPE" hide-details/>
                    </template>
                    <span>{{$t("eventlist_label7")}}</span>
                  </v-tooltip>
                </v-col>
                <v-col cols="6" md="4">
                  <v-tooltip bottom>
                    <template v-slot:activator="{ on }">
                      <v-checkbox dense :label="$t('eventlist_label23')" v-on="on" v-model="editedItem.USE_MAPBOX" hide-details/>
                    </template>
                    <span>{{$t("eventlist_label24")}}</span>
                  </v-tooltip>
                </v-col>
                <v-col cols="6" md="4">
                  <v-checkbox dense :label="$t('eventlist_label20')" v-model="editedItem.USE_LAN" hide-details/>
                </v-col>
                <v-col cols="6" md="4" v-if="editedItem.USE_MAPBOX">
                  <v-text-field outlined dense v-model="editedItem.MAPCODE" :label="$t('eventlist_col13')" hide-details></v-text-field>
                </v-col>

              </v-row>

              <v-row dense class="mt-3">
                <v-col cols="12" class="pa-0">
                  <label style="font-weight:bold;font-size:16px">{{$t("eventlist_label8")}}</label>
                </v-col>
                <v-col cols="6" md="4">
                  <v-checkbox dense :label="$t('eventlist_label9')" v-model="editedItem.ALIM_DATE" hide-details/>
                </v-col>
                <v-col cols="6" md="4">
                  <v-checkbox dense :label="$t('eventlist_label10')" v-model="editedItem.ALIM_INFO" @change="change_aliminfo" hide-details/>
                </v-col>
                <v-col cols="6" md="4">
                  <v-tooltip bottom>
                    <template v-slot:activator="{ on }">
                      <v-checkbox dense :label="$t('eventlist_label11')" v-model="editedItem.ALIM_KIOSK" 
                      :disabled="editedItem.ALIM_INFO == 0" v-on="on"
                      hide-details/>
                    </template>
                    <span>{{$t("eventlist_label34")}}</span>
                  </v-tooltip>
                </v-col>
                <v-col cols="6" md="4">
                  <v-checkbox dense :label="$t('eventlist_label12')" v-model="editedItem.ALIM_AVG" hide-details/>
                </v-col>
                <v-col cols="6" md="4">
                  <v-checkbox dense :label="$t('eventlist_label25')" v-model="editedItem.ALIM_OPTION" hide-details/>
                </v-col>
                <v-col cols="6" md="4">
                  <v-checkbox dense :label="$t('eventlist_label30')" v-model="editedItem.ALIM_TIME" hide-details/>
                </v-col>
              </v-row>
              
              <v-row dense class="mt-3">
                <v-col cols="12" class="pa-0">
                  <label style="font-weight:bold;font-size:16px">{{$t("eventlist_label38")}}</label>
                </v-col>
                <v-col cols="12" md="12">
                  <v-textarea outlined dense v-model="editedItem.ALIM_TEXT" hide-details
                    :disabled="editedItem.ALIM_INFO == 0" rows="3"
                    />
                </v-col>
              </v-row>

              <v-row dense class="mt-3">
                <v-col cols="12" class="pa-0">
                  <label style="font-weight:bold;font-size:16px">{{$t("eventlist_label42")}}</label>
                </v-col>
                <v-col cols="6" md="6">
                  <v-checkbox dense :label="$t('eventlist_label43')" v-model="editedItem.USE_REGPAGE" hide-details/>
                </v-col>
                <v-col cols="6" md="6">
                  <v-checkbox dense :label="$t('eventlist_label51')" v-model="editedItem.USE_REGSINGLE" hide-details/>
                </v-col>
                <v-col cols="12" md="12">
                  <v-checkbox dense :label="$t('eventlist_label44')" v-model="editedItem.USE_LANDPAGE" hide-details/>
                </v-col>
                <v-col cols="6" md="6">
                  <v-checkbox dense :label="$t('eventlist_label45')" v-model="editedItem.USE_KOR" hide-details/>
                </v-col>
                <v-col cols="6" md="6">
                  <v-checkbox dense :label="$t('eventlist_label46')" v-model="editedItem.USE_ENG" hide-details/>
                </v-col>
              </v-row>

              <v-row dense class="mt-3">
                <v-col cols="12" class="pa-0">
                  <label style="font-weight:bold;font-size:16px">{{$t("eventlist_label48")}}</label>
                </v-col>
                <v-col cols="6" md="4">
                  <v-checkbox dense :label="$t('eventlist_label49')" v-model="editedItem.SHOW_INFO" hide-details/>
                </v-col>
                <v-col cols="6" md="4">
                  <v-checkbox dense :label="$t('eventlist_label50')" v-model="editedItem.SHOW_CANCEL" hide-details/>
                </v-col>
              </v-row>

              <v-row dense class="mt-3">
                <v-col cols="12" class="pa-0">
                  <label style="font-weight:bold;font-size:16px">{{$t("eventlist_label13")}}</label>
                </v-col>
                <v-col cols="6" md="4" v-if="grade > 90">
                  <v-checkbox dense :label="$t('eventlist_label14')" v-model="editedItem.USE_NOTICE" hide-details/>
                </v-col>
                <v-col cols="6" md="4" v-if="grade > 90">
                  <v-checkbox dense :label="$t('eventlist_label15')" v-model="editedItem.USE_SCHEDULE" hide-details/>
                </v-col>
                <v-col cols="6" md="4" v-if="grade > 90">
                  <v-checkbox dense :label="$t('eventlist_label16')" v-model="editedItem.USE_GALLARY" hide-details/>
                </v-col>
                <v-col cols="6" md="4" v-if="grade > 90">
                  <v-checkbox dense :label="$t('eventlist_label17')" v-model="editedItem.USE_MAP" hide-details/>
                </v-col>
                <v-col cols="6" md="4" v-if="grade > 90">
                  <v-checkbox dense :label="$t('eventlist_label28')" v-model="editedItem.USE_REGDATE" hide-details/>
                </v-col>
                <v-col cols="6" md="4" v-if="grade > 90">
                  <v-checkbox dense :label="$t('eventlist_label29')" v-model="editedItem.USE_REFUND" hide-details/>
                </v-col>
                <v-col cols="6" md="4">
                  <v-checkbox dense :label="$t('eventlist_label18')" v-model="editedItem.USE_PRICY" hide-details/>
                </v-col>
                <v-col cols="6" md="4">
                  <v-checkbox dense :label="$t('eventlist_label19')" v-model="editedItem.USE_MKT" hide-details/>
                </v-col>
                <v-col cols="6" md="4" v-if="grade > 90">
                  <v-checkbox dense :label="$t('eventlist_label32')" v-model="editedItem.USE_INFO" hide-details/>
                </v-col>
                <v-col cols="6" md="4" v-if="grade > 90">
                  <v-checkbox dense :label="$t('eventlist_label33')" v-model="editedItem.USE_POSTER" hide-details/>
                </v-col>
                <v-col cols="6" md="4" v-if="grade > 90">
                  <v-checkbox dense :label="$t('eventlist_label31')" v-model="editedItem.USE_PASSWORD" hide-details/>
                </v-col>
                <v-col cols="6" md="4" >
                  <v-checkbox dense :label="$t('eventlist_label52')" v-model="editedItem.USE_SURVEY" hide-details/>
                </v-col>
              </v-row>

              <v-row dense class="mt-3">
                <v-col cols="12" class="pa-0">
                  <label style="font-weight:bold;font-size:16px">{{$t("eventlist_label26")}}</label>
                </v-col>
                <v-col cols="12">
                  <v-checkbox dense :label="$t('eventlist_label27')" v-model="editedItem.USE_REGTALK" hide-details/>
                </v-col>

                <!-- 등록시 메일 발송 설정 -->
                <template v-if="this.editedIndex > -1">
                  <v-col cols="12">
                    <v-checkbox dense :label="$t('eventlist_label47')" v-model="editedItem.USE_REGMAIL" hide-details/>
                  </v-col>

                  <v-col cols="12" md="12" v-if="editedItem.USE_REGMAIL == 1">
                    <v-checkbox dense :label="$t('eventlist_label36')" v-model="editedItem.USE_MAILLOCAL" hide-details/>
                  </v-col>
                  <v-col cols="6" class="mt-5" v-if="editedItem.USE_REGMAIL == 1 && editedItem.USE_MAILLOCAL == 1">
                    <label style="font-weight:bold;font-size:16px">{{ $t('emailtemp_col1') }}</label>
                  </v-col>
                  <v-col cols="6" align="end" v-if="editedItem.USE_REGMAIL == 1 && editedItem.USE_MAILLOCAL == 1">
                    <comemailtempdialog @callback="selectemailtemplate" :com_idx="editedItem.COM_IDX" :event_idx="editedItem.IDX" />
                  </v-col>
                  <v-col cols="12" v-if="editedItem.USE_REGMAIL == 1 && editedItem.USE_MAILLOCAL == 1">
                    <v-text-field dense v-model="editedItem.ETEMP_TITLE" hide-details disabled></v-text-field>
                  </v-col>

                  <v-col cols="12" md="12" v-if="editedItem.USE_REGMAIL == 1">
                    <v-checkbox dense :label="$t('eventlist_label37')" v-model="editedItem.USE_MAILFOREIGNER" hide-details/>
                  </v-col>
                  <v-col cols="6" class="mt-5" v-if="editedItem.USE_REGMAIL == 1 && editedItem.USE_MAILFOREIGNER == 1">
                    <label style="font-weight:bold;font-size:16px">{{ $t('emailtemp_col1') }}</label>
                  </v-col>
                  <v-col cols="6" align="end" v-if="editedItem.USE_REGMAIL == 1 && editedItem.USE_MAILFOREIGNER == 1">
                    <comemailtempdialog @callback="selectemailtemplate2" :com_idx="editedItem.COM_IDX" :event_idx="editedItem.IDX" />
                  </v-col>
                  <v-col cols="12" v-if="editedItem.USE_REGMAIL == 1 && editedItem.USE_MAILFOREIGNER == 1">
                    <v-text-field dense v-model="editedItem.ETEMP_TITLE2" hide-details disabled></v-text-field>
                  </v-col>

                </template>
                <template v-else>
                  <v-col cols="12">
                    <div>{{ $t('eventinfo_label115') }}</div>
                  </v-col>
                </template>

              </v-row>


              <v-row dense class="mt-3">
                <v-col cols="12" class="pa-0">
                  <label style="font-weight:bold;font-size:16px">{{$t("eventlist_label35")}}</label>
                </v-col>
                <v-col cols="6" md="4">
                  <v-checkbox dense :label="$t('eventlist_label36')" v-model="editedItem.USE_LOCAL" hide-details/>
                </v-col>
                <v-col cols="6" md="4">
                  <v-checkbox dense :label="$t('eventlist_label37')" v-model="editedItem.USE_FOREIGNER" hide-details/>
                </v-col>
              </v-row>

              <v-row dense class="mt-5"> 
                  <eventtypedialog :typename="editedItem.TYPENAME" @callback="eventsearchcb"></eventtypedialog>
              </v-row>
              <template v-if="grade == 99">
              <v-row dense> 
                  <comdialog :comname="editedItem.COM_NAME" @callback="comdialogcb"></comdialog>
              </v-row>
              </template>

              <template v-if="editedIndex > -1">
                <template v-if="editedItem.STATE == 0">
                  <v-row dense justify="center"> 
                    <v-btn color="success" rounded lg @click="openevent(editedItem.IDX, editedItem.ADMIN_IDX)">{{$t("eventlist_label21")}}</v-btn>
                  </v-row>
                </template>
                <template v-else>
                <v-row dense justify="center"> 
                  <v-btn color="error" rounded lg @click="closeevent(editedItem.IDX, editedItem.ADMIN_IDX)">{{$t("eventlist_label22")}}</v-btn>
                </v-row>
                </template>
              </template>

            </v-container>
          </v-card-text>
          <v-card-actions>
            <v-row justify="center">
            <v-btn class="dialog_cancel_btn mr-5" rounded large @click="close">{{$t("common_cancel")}}</v-btn>
            <v-btn class="dialog_btn" rounded large @click="save">{{$t("common_ok")}}</v-btn>
            </v-row>
          </v-card-actions>
        </v-card>
      </v-dialog>  
    </v-row>

    <v-row dense align="center">

      <v-col cols="12" md="2" sm="12" xs="12" class="pa-0">
        <label class="menunamestyle">{{this.$session.get("MENUNAME")}}</label>
      </v-col>
      
      <template v-if="grade >= 50">
        <v-col class="pa-0" cols="12" md="4" sm="12" xs="12">
          <comdialog  :comname="SEARCH_COM_NAME" @cancelcallback="comsearchclear" @callback="comsearchcb"></comdialog>
        </v-col>
      </template>
      <template v-else>
        <v-spacer/>
      </template>

      <v-col cols="12" md="6" sm="12" xs="12" class="pa-0">
        <v-row dense no-gutters align="center">
          <v-col cols="8" class="pa-0">
            <v-text-field 
              dense single-line clearable
              @keyup.enter="search_run" 
              v-model="search_keyword" 
              :placeholder="$t('common_search_holder')"
              outlined height="43"
              color="#808080"
              hide-details
              />
          </v-col>
          <v-col cols="2" align="center">
            <v-btn style="width:94%" class="search_btn_freesize" elevation="0" outlined large @click="search_run">{{$t("common_search")}}</v-btn>
          </v-col>
          <v-col cols="2" align="center">
            <v-btn style="width:94%" class="search_btn_freesize" elevation="0" outlined large @click="newinsert">{{$t("common_insert")}}</v-btn>
          </v-col>
        </v-row>
      </v-col>
      
  </v-row>

  <v-row dense no-gutters>
    <label class="total_label">{{$t("common_total")}}</label><label class="total_label">{{totalcnt}}</label>
  </v-row>
    
  <v-row align="start">
    <v-col class="pa-1">
      <!-- 테이블 -->
      <v-data-table
        :headers="headers"
        :items="itemList"
        :no-data-text="$t('common_nodata')"
        hide-default-footer
        class="datatablestyle"
        :items-per-page="pagerow"
        :search="search"  
        item-key="IDX"
        :loading="loading"
        >
        <template v-slot:header.IDX>
          <a :class="sort_name=='IDX'?'cheader_sortselect':'cheader_sort'" @click="customsort('IDX')">{{$t("eventlist_col1")}}</a>
        </template>
        <template v-slot:header.NAME>
          <a :class="sort_name=='NAME'?'cheader_sortselect':'cheader_sort'" @click="customsort('NAME')">{{$t("eventlist_col2")}}</a>
        </template>
        <template v-slot:header.COM_NAME>
          <a :class="sort_name=='COM_NAME'?'cheader_sortselect':'cheader_sort'" @click="customsort('COM_NAME')">{{$t("eventlist_col3")}}</a>
        </template>
        <template v-slot:header.TYPENAME>
          <a :class="sort_name=='TYPENAME'?'cheader_sortselect':'cheader_sort'" @click="customsort('TYPENAME')">{{$t("eventlist_col4")}}</a>
        </template>
        <template v-slot:header.STATE_NAME>
          <a :class="sort_name=='STATE_NAME'?'cheader_sortselect':'cheader_sort'" @click="customsort('STATE_NAME')">{{$t("eventlist_col5")}}</a>
        </template>
        <template v-slot:header.PART_NAME>
          <a :class="sort_name=='PART_NAME'?'cheader_sortselect':'cheader_sort'" @click="customsort('PART_NAME')">{{$t("eventlist_col6")}}</a>
        </template>
        <template v-slot:header.APP_NAME>
          <a :class="sort_name=='APP_NAME'?'cheader_sortselect':'cheader_sort'" @click="customsort('APP_NAME')">{{$t("eventlist_col7")}}</a>
        </template>
        <template v-slot:header.EVENT_START_NAME>
          <a :class="sort_name=='EVENT_START'?'cheader_sortselect':'cheader_sort'" @click="customsort('EVENT_START')">{{$t("eventlist_col8")}}</a>
        </template>
        <template v-slot:header.EVENT_END_NAME>
          <a :class="sort_name=='EVENT_END'?'cheader_sortselect':'cheader_sort'" @click="customsort('EVENT_END')">{{$t("eventlist_col9")}}</a>
        </template>
        <template v-slot:header.link>
          <label class="cheader_normal" >{{$t("eventlist_col10")}}</label>
        </template>
        <template v-slot:header.link3>
          <label class="cheader_normal" >{{$t("eventlist_col14")}}</label>
        </template>
        <template v-slot:header.link2>
          <label class="cheader_normal" >{{$t("eventlist_col11")}}</label>
        </template>
        <template v-slot:header.actions>
          <label class="cheader_normal" >{{$t("eventlist_col12")}}</label>
        </template>

        <template v-slot:item.STATE_NAME="{ item }">  
          <template v-if="item.STATE == 1">
            <a @click="closeevent(item.IDX, item.ADMIN_IDX)" >{{$t('eventlist_value1')}}</a>
          </template>
          <template v-else>
            <a @click="openevent(item.IDX, item.ADMIN_IDX)" style="color:#ff0000">{{$t('eventlist_value2')}}</a>
          </template>
        </template>

        <template v-slot:item.PART_NAME="{ item }">
          <label>{{ item.PART_TYPE == 0 ? $t('eventlist_value4') : $t('eventlist_value3') }}</label>
        </template>
        <template v-slot:item.APP_NAME="{ item }">
          <label>{{ item.APP_TYPE == 0 ? $t('eventlist_value6') : $t('eventlist_value5') }}</label>
        </template>

        <template v-slot:item.link="{ item }">  
            <v-icon small @click="linkcopy(item)">mdi-link</v-icon>
        </template>     
        <template v-slot:item.link3="{ item }">  
          <v-icon small @click="linkcopy3(item)">mdi-link</v-icon>
      </template>     
        <template v-slot:item.link2="{ item }">  
            <v-icon small @click="linkcopy2(item)">mdi-link</v-icon>
        </template>     
        <template v-slot:item.actions="{ item }">  
            <v-icon class="mr-2" small @click="edit_item(item)">mdi-pencil</v-icon>
            <v-icon small @click="delete_item(item)">mdi-delete</v-icon>
        </template>     
      </v-data-table>
    </v-col>
  </v-row>

  <!-- 하단 페이징 영역 -->
  <v-row align="start">
    <v-col cols="12" md="1"/>
    <v-col cols="12" md="2">
      <v-text-field
        v-model="search"
        append-icon="search"
        :label="$t('common_filter')"
        single-line
        hide-details
        outlined height="43"
        color="#808080"
        dense
        />
    </v-col>
    <v-col cols="12" md="6" class="d-flex justify-center">
      <v-btn v-if="bottompage > 10" icon  small @click="prev()"><v-icon dark>mdi-chevron-left</v-icon></v-btn>
      <span v-for="n in subpage" :key="n.id">
          <span v-if="page == bottompage-1+n">
              <v-btn color="red" icon small @click="loadpage(bottompage-1+n)">{{bottompage-1+n}}</v-btn>
          </span>
          <span v-else>
              <v-btn icon small @click="loadpage(bottompage-1+n)">{{bottompage-1+n}}</v-btn>
          </span>
      </span>
      <v-btn v-if="subpage == 10" icon small @click="next()" ><v-icon dark>mdi-chevron-right</v-icon></v-btn>
    </v-col>
    <v-col cols="12" md="2">
      <v-select
        v-model="pagerow"
        :items="pagerow_combo"
        item-text="NAME"      
        item-value="VALUE"
        :label="$t('common_rownum')"
        min-width="150px"
        outlined height="43"
        color="#808080"
        dense
        ></v-select>
    </v-col>
    <v-col cols="12" md="1"/>
  </v-row>

  
  

  </v-container>
</template>

<script>
import dateFormat from 'dateformat'
import moment from 'moment'
export default {
    data: () => ({

      //필수 페이징 파라메터
      totalcnt : 0,       //전체 아이템 개수
      page : 0,
      maxpage : 0,        //전체 페이지 개수
      startpage : 1,      //시작 인덱스
      bottompage : 1,     //하단 페이징 번호의 시작점을 계산하기 위한 변수
      subpage : 1,       //하단 페이징 번호의 종료점을 계산하기 위한 변수
      loading : false,    //로딩 표시

      sort_name: 'IDX',
      sort_type: true,    //true : DESC, false: ASC

      //CRUD 관련
      dialogTitle: '추가하기',   //다이얼로그 제목
      editedIndex: -1,          //-1이면 신규, -1보다 크면 업데이트
      dialog:false,


      defaultItem: {
          COM_IDX:'',
          NAME:'',
          COM_NAME:'',
          STATE:1,
          TYPE_IDX: -1,
          TYPENAME: '',
          PART_TYPE:0,
          APP_TYPE:1,
          PAY_TYPE:1,
          COL_TYPE:0,

          ALIM_DATE:1,
          ALIM_INFO:1,
          ALIM_AVG:0,
          ALIM_KIOSK:1,
          ALIM_OPTION:1,
          ALIM_TIME:0,
          ALIM_TEXT:"",
          
          MAPCODE:'',
          USE_MAPBOX:0,
          USE_NOTICE:1,
          USE_SCHEDULE:1,
          USE_GALLARY:1,
          USE_MAP:1,
          USE_LAN:0,
          USE_PRICY:1,
          USE_LOCAL:1,
          USE_FOREIGNER:1,
          USE_MKT:1,
          USE_SURVEY:0,
          USE_REGTALK:1,
          USE_PASSWORD:0,
          USE_INFO:1,
          USE_POSTER:0,
          USE_REGDATE:1,
          USE_REFUND:1,

          USE_REGPAGE:1,
          USE_REGSINGLE:0,
          USE_LANDPAGE:0,
          USE_KOR:1,
          USE_ENG:1,

          USE_REGMAIL : 0,
          USE_MAILLOCAL : 0,
          USE_MAILFOREIGNER:0,

          SHOW_INFO: 1,
          SHOW_CANCEL: 1,

          ETEMP_IDX: null,    //알림메일용 템플릿 인덱스스
          ETEMP_TITLE: "",

          EVENT_START: dateFormat(new Date(), "yyyy-mm-dd 09:00"),
          EVENT_END:   dateFormat(new Date(), "yyyy-mm-dd 18:00"),
      },
      editedItem: {
      },
      

      //테이블 정의
      headers: [
        {text: '행사번호', value: 'IDX', width:120, sortable: false, align:'center'},
        {text: '행사명', value: 'NAME', sortable: false, align:'center', width:300},
        {text: '기업명', value: 'COM_NAME', sortable: false, align:'center', width:200},
        {text: '행사타입', value: 'TYPENAME', width:120, sortable: false, align:'center' },
        {text: '상태', value: 'STATE_NAME', width:120, sortable: false, align:'center' },
        {text: '참여기업', value: 'PART_NAME', width:120, sortable: false, align:'center' },
        {text: '앱노출', value: 'APP_NAME', width:120, sortable: false, align:'center' },
        
        {text: '입장 시작일시', value: 'EVENT_START_NAME', width:160, sortable: false, align:'center' },
        {text: '입장 종료일시', value: 'EVENT_END_NAME', width:160, sortable: false, align:'center' },
        {text: '등록링크', value: 'link', width:100, sortable: false, align:'center'},
        {text: '등록링크(영문)', value: 'link3', width:100, sortable: false, align:'center'},
        {text: '기업링크', value: 'link2', width:100, sortable: false, align:'center'},
        {text: '수정/삭제', value: 'actions', width:100, sortable: false, align:'center'}
      ],
      itemList: [],
      
      search_keyword : '',
      search: '',         //필터링용 검색어

      //한 페이지 ROW 개수 설정
      pagerow : 20,       //한 페이지에 보여줄 row수
      pagerow_combo : [
          {NAME:'20', VALUE:20}
        , {NAME:'50', VALUE:50}
        , {NAME:'100', VALUE:100}
        , {NAME:'200', VALUE:200}
      ],    
      
      STATELIST: [
          {name:'비활성', name2:"Disable",   value:0}
        , {name:'활성', name2:"Enable", value:1}
      ],

      //추가 변수들
      PARTLIST: [
          {name:'사용안함', name2:"Not used",value:0}
        , {name:'사용', name2:"Use",  value:1}
      ],

      APPTYPELIST: [
          {name:'노출안함', name2:"No exposure", value:0}
        , {name:'노출', name2:"Exposure",   value:1}
      ],
      
      SEARCH_COM_IDX: '',
      SEARCH_COM_NAME: '',
      grade : 0,
      
    }),

    mounted(){
      if(this.$session.get("GRADE") < 10){
        this.$alert(this.$t("common_nograde"));
        this.$router.push("Login");
        return;
      }

      this.SEARCH_COM_IDX    = this.$session.get("COM_IDX");
      this.SEARCH_COM_NAME   = this.$session.get("COM_NAME");
      this.grade = this.$session.get("GRADE");

      if(this.$session.exists("ADMIN_IDX")){
        this.initpage();
      }else{
        //키값 없으면 로그인으로
        this.$router.push("Login");
      }
    },

    create(){
      //this.$hostname = window.location.hostname;
    },

    methods: {

      selectemailtemplate(item){
        this.editedItem.ETEMP_IDX   = item.ETEMP_IDX;
        this.editedItem.ETEMP_TITLE = item.ETEMP_TITLE;
        this.$forceUpdate();
      },

      selectemailtemplate2(item){
        this.editedItem.ETEMP_IDX2   = item.ETEMP_IDX;
        this.editedItem.ETEMP_TITLE2 = item.ETEMP_TITLE;
        this.$forceUpdate();
      },

      change_aliminfo(){
        //console.log("change_aliminfo " + this.editedItem.ALIM_INFO);
      },

      openevent(event_idx, admin_idx){

        //해당 행사의 모든 준비가 완료되었는지 체크하여 이상이 없으면 상태값을 활성으로 변경한다.

        this.$confirm(this.$t('eventlist_msg1')).then(() => {

          this.loading = true;
          this.$http.post(this.$host+'/api/EventStateEnable',{
                IDX: event_idx
              , ADMIN_IDX: admin_idx
              , LAN_CODE:this.$i18n.locale
          },{headers: { accesstoken:this.$session.get("ACCESSTOKEN"), reflashtoken:this.$session.get("REFLASHTOKEN")}})
          .then((result)=>{
            this.loading = false;
            if(result.data.resultCode == 0){
              //토큰 저장
              if(result.data.accesstoken != null && result.data.accesstoken.length > 0){
                this.$session.set("ACCESSTOKEN",   result.data.accesstoken);
              }
              if(result.data.reflashtoken != null && result.data.reflashtoken.length > 0){
                this.$session.set("REFLASHTOKEN",   result.data.reflashtoken);
              }
              
                this.$fire({
                  title: this.$t('eventlist_msg2'),
                  text: this.$t('eventlist_msg3'),
                  type: "success"
                }).then(r => {
                  r;
                  const p = this.page;
                  this.page = 0;
                  this.loadpage(p);
                });

            }else if(result.data.resultCode == 2){
              //로그인 필요
              this.$alert(this.$t("common_tokener"));
              this.$session.clear("ADMIN_IDX");
              this.$session.clear("COM_IDX");
              this.$session.clear("ACNT_IDX");
              this.$session.clear("GRADE");
              this.$session.clear("COM_NAME");
              this.$session.clear("ACCESSTOKEN");
              this.$session.clear("REFLASHTOKEN");
              this.$router.push('Login');   //로그인 페이지로 이동

            }else{
                const msg_list = result.data.resultMsg;
                var error_msg = "";
                msg_list.forEach(element => {
                    error_msg += element + "\n\n";
                });
                
                /*
                this.$fire({
                  title: "Title",
                  text: error_msg,
                  type: "success",
                  timer: 3000
                }).then(r => {
                  console.log(r.value);
                });
                */
                alert(error_msg);
                const p = this.page;
                this.page = 0;
                this.loadpage(p);

            }
          })
          // eslint-disable-next-line no-unused-vars
          .catch((error)=>{
            this.loading = false;
            this.$alert(this.$t("common_edit_fail"));
          });
          this.close();

        });    

      },

      closeevent(event_idx, admin_idx){

        this.$confirm(this.$t('eventlist_msg4')).then(() => {

          //해당 행사를 비활성 처리한다.
          this.loading = true;
          this.$http.post(this.$host+'/api/EventStateDisable',{
                IDX: event_idx
              , ADMIN_IDX: admin_idx
          },{headers: { accesstoken:this.$session.get("ACCESSTOKEN"), reflashtoken:this.$session.get("REFLASHTOKEN")}})
          .then((result)=>{
            this.loading = false;
            if(result.data.resultCode == 0){
              //토큰 저장
              if(result.data.accesstoken != null && result.data.accesstoken.length > 0){
                this.$session.set("ACCESSTOKEN",   result.data.accesstoken);
              }
              if(result.data.reflashtoken != null && result.data.reflashtoken.length > 0){
                this.$session.set("REFLASHTOKEN",   result.data.reflashtoken);
              }
                this.$alert(this.$t('eventlist_msg5')).then(()=>{
                  const p = this.page;
                  this.page = 0;
                  this.loadpage(p);
                });

            }else if(result.data.resultCode == 2){
              //로그인 필요
              this.$alert(this.$t("common_tokener"));
              this.$session.clear("ADMIN_IDX");
              this.$session.clear("COM_IDX");
              this.$session.clear("ACNT_IDX");
              this.$session.clear("GRADE");
              this.$session.clear("COM_NAME");
              this.$session.clear("ACCESSTOKEN");
              this.$session.clear("REFLASHTOKEN");
              this.$router.push('Login');   //로그인 페이지로 이동

            }else{
                this.$alert(this.$t("common_edit_fail"));
            }
          })
          // eslint-disable-next-line no-unused-vars
          .catch((error)=>{
            this.loading = false;
            this.$alert(this.$t("common_edit_fail"));
          });
          this.close();

        });

      },

      customsort(sortname){
        this.sort_name = sortname;
        this.sort_type = !this.sort_type;
        this.loadpage(this.page);
      },


      prev(){
          this.bottompage = this.bottompage - 10 >= 1 ? this.bottompage - 10 : 1;
          this.subpage = this.maxpage - this.bottompage >= 10 ? 10 : this.maxpage - this.bottompage+1;
          var temp_page = this.bottompage + this.subpage - 1; //이전을 누르면 가장 끝 번호 선택
          this.loadpage(temp_page);
      },
      next(){
          this.bottompage = this.bottompage + 10 <= this.maxpage ? this.bottompage + 10 : this.maxpage;
          this.subpage = this.maxpage - this.bottompage >= 10 ? 10 : this.maxpage - this.bottompage+1;
          var temp_page = this.bottompage;
          this.loadpage(temp_page);
      },

      makepaging(){
        var div1 = this.totalcnt / this.pagerow; 
        var div2 = this.totalcnt % this.pagerow;
        if(div2 == 0){  
            this.maxpage = parseInt(div1);    
        }else{
            this.maxpage = parseInt(div1+1);
        }
        if(this.bottompage == 1){
          this.subpage = this.maxpage - this.bottompage >= 10 ? 10 : this.maxpage - this.bottompage+1;
        }
      },

      loadpage(p){
          
          this.itemList.splice(0, this.itemList.length);   //데이터 초기화
          
          this.loading = true;
          this.page = p;

          this.$http.post(this.$host+'/api/EventList',{
                search_keyword: this.search_keyword == null || this.search_keyword == undefined ?  '' : escape(this.search_keyword)
              , sort_name:this.sort_name
              , sort_type: this.sort_type==true ? "DESC" : "ASC" 
              , page: this.page
              , pagerow: this.pagerow
              , ADMIN_IDX: this.$session.get("ADMIN_IDX")
              , COM_IDX: this.SEARCH_COM_IDX
              , LAN_CODE:this.$i18n.locale
          },{headers: { accesstoken:this.$session.get("ACCESSTOKEN"), reflashtoken:this.$session.get("REFLASHTOKEN")}})
          .then((result)=>{
            
            if(result.data.resultCode == 0){

              //토큰 저장
              if(result.data.accesstoken != null && result.data.accesstoken.length > 0){
                this.$session.set("ACCESSTOKEN",   result.data.accesstoken);
              }
              if(result.data.reflashtoken != null && result.data.reflashtoken.length > 0){
                this.$session.set("REFLASHTOKEN",   result.data.reflashtoken);
              }

                this.totalcnt = result.data.totalcnt;
                this.makepaging();
                const list = result.data.resultData;

                list.forEach(element => {
                    this.itemList.push(element); 
                });

                //요걸 나중에 해줘야 무한반복이 안된다.
                this.loading = false;

            }else if(result.data.resultCode == 2){
              //로그인 필요
              this.loading = false;
              this.$alert(this.$t("common_tokener"));
              this.$session.clear("ADMIN_IDX");
              this.$session.clear("COM_IDX");
              this.$session.clear("ACNT_IDX");
              this.$session.clear("GRADE");
              this.$session.clear("COM_NAME");
              this.$session.clear("ACCESSTOKEN");
              this.$session.clear("REFLASHTOKEN");
              this.$router.push('Login');   //로그인 페이지로 이동

            }else{
              this.loading = false;
            }
          })
          // eslint-disable-next-line no-unused-vars
          .catch((error)=>{
            this.loading = false;
            if(error.message == 'Request failed with status code 429')
            {
              this.$alert(this.$t("common_reqer"));
            }else{
              this.$alert(error.message);
            }
          });

      },

      initpage(){
        //첫페이지 로드
        this.loadpage(1);
      },      

      //다이얼로그 닫기
      close () {
        this.dialog     = false
        this.dialog_pw  = false
        setTimeout(() => {
          this.editedItem = Object.assign({}, this.defaultItem)
          this.editedIndex = -1
        }, 300)
      },

      //추가 저장
      save () {
        
        if(this.editedItem.NAME  == undefined || this.editedItem.NAME.length < 1){
          this.$alert(this.$t('eventlist_msg6'));
          return;
        } 

        const event_start = new Date(this.editedItem.EVENT_START)
        const event_end   = new Date(this.editedItem.EVENT_END)
        if(event_start > event_end){
          this.$alert(this.$t('eventlist_msg7'));
          return;
        }

        if(this.editedItem.COM_NAME == undefined || this.editedItem.COM_NAME.length < 1){
          this.$alert(this.$t('eventlist_msg8'));
          return;
        } 

        if(this.editedItem.USE_LOCAL == 0 && this.editedItem.USE_FOREIGNER == 0){
          this.$alert(this.$t('eventlist_msg11'));
          return;
        }

        if (this.editedIndex > -1) {

          //수정
          this.loading = true;
          this.$http.post(this.$host+'/api/EventUpdate',{
                COM_IDX: this.editedItem.COM_IDX
              , NAME: escape(this.editedItem.NAME)
              , TYPE_IDX : this.editedItem.TYPE_IDX
              , PART_TYPE : this.editedItem.PART_TYPE
              , APP_TYPE : this.editedItem.APP_TYPE
              , PAY_TYPE : this.editedItem.PAY_TYPE
              , COL_TYPE : this.editedItem.COL_TYPE
              , ALIM_TEXT: this.editedItem.ALIM_TEXT == null || this.editedItem.ALIM_TEXT == undefined ? '' : escape(this.editedItem.ALIM_TEXT)
              , ALIM_DATE : this.editedItem.ALIM_DATE
              , ALIM_INFO : this.editedItem.ALIM_INFO
              , ALIM_KIOSK : this.editedItem.ALIM_KIOSK
              , ALIM_AVG : this.editedItem.ALIM_AVG
              , ALIM_OPTION : this.editedItem.ALIM_OPTION
              , ALIM_TIME : this.editedItem.ALIM_TIME
              , MAPCODE : this.editedItem.MAPCODE == null || this.editedItem.MAPCODE == undefined ? '' : this.editedItem.MAPCODE
              , USE_MAPBOX : this.editedItem.USE_MAPBOX
              , USE_NOTICE : this.editedItem.USE_NOTICE
              , USE_SCHEDULE : this.editedItem.USE_SCHEDULE
              , USE_GALLARY : this.editedItem.USE_GALLARY
              , USE_MAP : this.editedItem.USE_MAP
              , USE_LAN : this.editedItem.USE_LAN
              , USE_PRICY : this.editedItem.USE_PRICY
              , USE_LOCAL : this.editedItem.USE_LOCAL
              , USE_FOREIGNER : this.editedItem.USE_FOREIGNER
              , USE_REGTALK : this.editedItem.USE_REGTALK
              , USE_MKT : this.editedItem.USE_MKT
              , USE_SURVEY : this.editedItem.USE_SURVEY
              , USE_PASSWORD : this.editedItem.USE_PASSWORD
              , USE_INFO : this.editedItem.USE_INFO
              , USE_POSTER : this.editedItem.USE_POSTER
              , USE_REGDATE : this.editedItem.USE_REGDATE
              , USE_REFUND : this.editedItem.USE_REFUND
              , USE_REGPAGE : this.editedItem.USE_REGPAGE
              , USE_REGSINGLE : this.editedItem.USE_REGSINGLE
              , USE_LANDPAGE : this.editedItem.USE_LANDPAGE
              , USE_KOR : this.editedItem.USE_KOR
              , USE_ENG : this.editedItem.USE_ENG
              , USE_REGMAIL : this.editedItem.USE_REGMAIL
              , USE_MAILLOCAL : this.editedItem.USE_MAILLOCAL
              , USE_MAILFOREIGNER : this.editedItem.USE_MAILFOREIGNER

              , ETEMP_IDX : this.editedItem.ETEMP_IDX
              , ETEMP_IDX2 : this.editedItem.ETEMP_IDX2
              , ETEMP_TITLE: this.editedItem.ETEMP_TITLE == null || this.editedItem.ETEMP_TITLE == undefined ? '' : escape(this.editedItem.ETEMP_TITLE)
              , ETEMP_TITLE2: this.editedItem.ETEMP_TITLE2 == null || this.editedItem.ETEMP_TITLE2 == undefined ? '' : escape(this.editedItem.ETEMP_TITLE2)

              , SHOW_INFO : this.editedItem.SHOW_INFO
              , SHOW_CANCEL : this.editedItem.SHOW_CANCEL

              , EVENT_START: dateFormat(this.editedItem.EVENT_START, "yyyy-mm-dd HH:MM")
              , EVENT_END: dateFormat(this.editedItem.EVENT_END, "yyyy-mm-dd HH:MM")
              , IDX: this.editedItem.IDX
              , ADMIN_IDX: this.editedItem.ADMIN_IDX
          },{headers: { accesstoken:this.$session.get("ACCESSTOKEN"), reflashtoken:this.$session.get("REFLASHTOKEN")}})
          .then((result)=>{
            this.loading = false;
            if(result.data.resultCode == 0){

              //토큰 저장
              if(result.data.accesstoken != null && result.data.accesstoken.length > 0){
                this.$session.set("ACCESSTOKEN",   result.data.accesstoken);
              }
              if(result.data.reflashtoken != null && result.data.reflashtoken.length > 0){
                this.$session.set("REFLASHTOKEN",   result.data.reflashtoken);
              }
                this.$alert(this.$t("common_edit_msg")).then(()=>{
                  const p = this.page;
                  this.page = 0;
                  this.loadpage(p);
                });

            }else if(result.data.resultCode == 2){
              //로그인 필요
              this.$alert(this.$t("common_tokener"));
              this.$session.clear("ADMIN_IDX");
              this.$session.clear("COM_IDX");
              this.$session.clear("ACNT_IDX");
              this.$session.clear("GRADE");
              this.$session.clear("COM_NAME");
              this.$session.clear("ACCESSTOKEN");
              this.$session.clear("REFLASHTOKEN");
              this.$router.push('Login');   //로그인 페이지로 이동

            }else{
                this.$alert(this.$t("common_edit_fail"));
            }
          })
          // eslint-disable-next-line no-unused-vars
          .catch((error)=>{
            this.loading = false;
            this.$alert(this.$t("common_edit_fail"));
          });


        }else{
          
          //신규
          this.loading = true;
          this.$http.post(this.$host+'/api/EventInsert',{
                COM_IDX: this.editedItem.COM_IDX
              , NAME: escape(this.editedItem.NAME)
              , TYPE_IDX: this.editedItem.TYPE_IDX
              , PART_TYPE : this.editedItem.PART_TYPE
              , APP_TYPE : this.editedItem.APP_TYPE
              , PAY_TYPE : this.editedItem.PAY_TYPE
              , COL_TYPE : this.editedItem.COL_TYPE
              , ALIM_TEXT: this.editedItem.ALIM_TEXT == null || this.editedItem.ALIM_TEXT == undefined ? '' : escape(this.editedItem.ALIM_TEXT)
              , ALIM_DATE : this.editedItem.ALIM_DATE
              , ALIM_INFO : this.editedItem.ALIM_INFO
              , ALIM_KIOSK : this.editedItem.ALIM_KIOSK
              , ALIM_AVG : this.editedItem.ALIM_AVG
              , ALIM_OPTION : this.editedItem.ALIM_OPTION
              , ALIM_TIME : this.editedItem.ALIM_TIME
              , USE_MAPBOX : this.editedItem.USE_MAPBOX
              , MAPCODE : this.editedItem.MAPCODE == null || this.editedItem.MAPCODE == undefined ? '' : this.editedItem.MAPCODE
              , USE_NOTICE : this.editedItem.USE_NOTICE
              , USE_SCHEDULE : this.editedItem.USE_SCHEDULE
              , USE_GALLARY : this.editedItem.USE_GALLARY
              , USE_MAP : this.editedItem.USE_MAP
              , USE_LAN : this.editedItem.USE_LAN
              , USE_PRICY : this.editedItem.USE_PRICY
              , USE_LOCAL : this.editedItem.USE_LOCAL
              , USE_FOREIGNER : this.editedItem.USE_FOREIGNER
              , USE_REGTALK : this.editedItem.USE_REGTALK
              , USE_MKT : this.editedItem.USE_MKT
              , USE_SURVEY : this.editedItem.USE_SURVEY
              , USE_PASSWORD : this.editedItem.USE_PASSWORD
              , USE_INFO : this.editedItem.USE_INFO
              , USE_POSTER : this.editedItem.USE_POSTER
              , USE_REGDATE : this.editedItem.USE_REGDATE
              , USE_REFUND : this.editedItem.USE_REFUND

              , USE_REGPAGE : this.editedItem.USE_REGPAGE
              , USE_REGSINGLE : this.editedItem.USE_REGSINGLE
              , USE_LANDPAGE : this.editedItem.USE_LANDPAGE
              , USE_KOR : this.editedItem.USE_KOR
              , USE_ENG : this.editedItem.USE_ENG
              , USE_REGMAIL : this.editedItem.USE_REGMAIL
              , USE_MAILLOCAL : this.editedItem.USE_MAILLOCAL
              , USE_MAILFOREIGNER : this.editedItem.USE_MAILFOREIGNER
              
              , SHOW_INFO : this.editedItem.SHOW_INFO
              , SHOW_CANCEL : this.editedItem.SHOW_CANCEL

              , EVENT_START: dateFormat(this.editedItem.EVENT_START, "yyyy-mm-dd HH:MM")
              , EVENT_END: dateFormat(this.editedItem.EVENT_END, "yyyy-mm-dd HH:MM")
              , ADMIN_IDX:this.$session.get("ADMIN_IDX")
          },{headers: { accesstoken:this.$session.get("ACCESSTOKEN"), reflashtoken:this.$session.get("REFLASHTOKEN")}})
          .then((result)=>{
            this.loading = false;
            if(result.data.resultCode == 0){

              //토큰 저장
              if(result.data.accesstoken != null && result.data.accesstoken.length > 0){
                this.$session.set("ACCESSTOKEN",   result.data.accesstoken);
              }
              if(result.data.reflashtoken != null && result.data.reflashtoken.length > 0){
                this.$session.set("REFLASHTOKEN",   result.data.reflashtoken);
              }
                this.$alert(this.$t('common_insert_msg')).then(()=>{
                  const p = this.page;
                  this.page = 0;
                  this.loadpage(p);
                });

            }else if(result.data.resultCode == 2){
              //로그인 필요
              this.$alert(this.$t("common_tokener"));
              this.$session.clear("ADMIN_IDX");
              this.$session.clear("COM_IDX");
              this.$session.clear("ACNT_IDX");
              this.$session.clear("GRADE");
              this.$session.clear("COM_NAME");
              this.$session.clear("ACCESSTOKEN");
              this.$session.clear("REFLASHTOKEN");
              this.$router.push('Login');   //로그인 페이지로 이동

            }else{
              this.$alert(this.$t("common_insert_fail"));
            }
          })
          // eslint-disable-next-line no-unused-vars
          .catch((error)=>{
            this.loading = false;
            this.$alert(this.$t("common_insert_fail"));
          });


        }

        this.close()
      },      

      //검색
      search_run(){
        this.loadpage(1);
      },
      
      //신규 추가
      newinsert(){
        this.dialogTitle = this.$t('common_insert_title');
        this.editedIndex  = -1;
        this.editedItem = Object.assign({}, this.defaultItem)
        this.editedItem.EVENT_START = moment(this.editedItem.EVENT_START).format("YYYY-MM-DDTHH:mm");
        this.editedItem.EVENT_END   = moment(this.editedItem.EVENT_END).format("YYYY-MM-DDTHH:mm");

        this.editedItem.COM_NAME = this.SEARCH_COM_NAME;
        this.editedItem.COM_IDX  = this.SEARCH_COM_IDX;
        this.dialog = true;
      },

      //아이템 수정
      edit_item(item){
        this.dialogTitle = this.$t('common_edit_title');
        this.editedIndex = this.itemList.indexOf(item)
        this.editedItem = Object.assign({}, item);
        
        this.editedItem.EVENT_START = moment(item.EVENT_START).format("YYYY-MM-DDTHH:mm");
        this.editedItem.EVENT_END   = moment(item.EVENT_END).format("YYYY-MM-DDTHH:mm");
        
        this.dialog = true;
      },

      linkcopy(item){
          
        if(this.$hostname == "admin.mnccom-reg.com"){
          window.navigator.clipboard.writeText('https://mnccom-reg.com/RunEventInfo?eventcode='+item.IDX);
        }else if(this.$hostname == "admin.pictcloud.com"){
          window.navigator.clipboard.writeText('https://pictcloud.com/RunEventInfo?eventcode='+item.IDX);
        }else{
          window.navigator.clipboard.writeText('https://fairpass.co.kr/RunEventInfo?eventcode='+item.IDX);
        }
        this.$alert(this.$t('eventlist_msg9'));

      },

      linkcopy3(item){
          
        if(this.$hostname == "admin.mnccom-reg.com"){
          window.navigator.clipboard.writeText('https://mnccom-reg.com/RunEventInfo?eventcode='+item.IDX+"&lan_code=1");
        }else if(this.$hostname == "admin.pictcloud.com"){
          window.navigator.clipboard.writeText('https://pictcloud.com/RunEventInfo?eventcode='+item.IDX+"&lan_code=1");
        }else{
          window.navigator.clipboard.writeText('https://fairpass.co.kr/RunEventInfo?eventcode='+item.IDX+"&lan_code=1");
        }
        this.$alert(this.$t('eventlist_msg9'));
  
      },
  
      linkcopy2(item){
        if(this.$hostname == "admin.mnccom-reg.com"){
          window.navigator.clipboard.writeText('https://mnccom-reg.com/PartEventInfo?eventcode='+item.IDX);
        }else if(this.$hostname == "admin.pictcloud.com"){
          window.navigator.clipboard.writeText('https://pictcloud.com/PartEventInfo?eventcode='+item.IDX);
        }else{
          window.navigator.clipboard.writeText('https://fairpass.co.kr/PartEventInfo?eventcode='+item.IDX);
        }
        this.$alert(this.$t('eventlist_msg10'));
      },

      //아이템 삭제
      delete_item(item){

        this.$confirm(this.$t("common_delete_msg"))
        .then(() => {
          this.loading = true;
          this.$http.post(this.$host+'/api/EventDelete',{
              IDX:item.IDX
            , ADMIN_IDX:item.ADMIN_IDX
          },{headers: { accesstoken:this.$session.get("ACCESSTOKEN"), reflashtoken:this.$session.get("REFLASHTOKEN")}})
          .then((result)=>{
            this.loading = false;
            if(result.data.resultCode == 0){

              //토큰 저장
              if(result.data.accesstoken != null && result.data.accesstoken.length > 0){
                this.$session.set("ACCESSTOKEN",   result.data.accesstoken);
              }
              if(result.data.reflashtoken != null && result.data.reflashtoken.length > 0){
                this.$session.set("REFLASHTOKEN",   result.data.reflashtoken);
              }
              this.$alert(this.$t("common_delete_com")).then(()=>{
                const p = this.page;
                this.page = 0;
                this.loadpage(p);
              });
              
            }else if(result.data.resultCode == 2){
              //로그인 필요
              this.$alert(this.$t("common_tokener"));
              this.$session.clear("ADMIN_IDX");
              this.$session.clear("COM_IDX");
              this.$session.clear("ACNT_IDX");
              this.$session.clear("GRADE");
              this.$session.clear("COM_NAME");
              this.$session.clear("ACCESSTOKEN");
              this.$session.clear("REFLASHTOKEN");
              this.$router.push('Login');   //로그인 페이지로 이동

            }else{
              this.$alert(this.$t("common_delete_fail"));
            }
            
          })
          // eslint-disable-next-line no-unused-vars
          .catch((error)=>{
              this.loading = false;
              this.$alert(this.$t("common_delete_error"));
          });      

        });

      },

      //업체선택 콜백
      comdialogcb(val){
        if(val.NAME.length > 0){
          this.editedItem.COM_NAME = val.NAME;
          this.editedItem.COM_IDX  = val.IDX;
        }else{
          this.$alert(this.$t('common_select_company'));
          return;
        }
      },

      //행사타입 콜백
      eventsearchcb(val){
        if(val.TYPENAME.length > 0){
          this.editedItem.TYPENAME = val.TYPENAME;
          this.editedItem.TYPE_IDX = val.IDX;
        }else{
          this.editedItem.TYPENAME = "";
          this.editedItem.TYPE_IDX = null;
        }
      },

      //검색조건 업체 설정
      comsearchcb(val1){
        if(val1.NAME.length > 0){
          this.SEARCH_COM_NAME = val1.NAME;
          this.SEARCH_COM_IDX  = val1.IDX;
        }else{
          this.SEARCH_COM_NAME = '';
          this.SEARCH_COM_IDX  = null;
        }
        this.$session.set("COM_IDX",  this.SEARCH_COM_IDX);
        this.$session.set("COM_NAME", this.SEARCH_COM_NAME);
        this.$session.set("EVENT_IDX", null);
        this.$session.set("EVENT_NAME", "");
        this.loadpage(1);
      },
      
      // eslint-disable-next-line no-unused-vars
      comsearchclear(var2){
          this.SEARCH_COM_IDX  = null;
          this.SEARCH_COM_NAME = '';
          this.$session.set("COM_IDX",  null);
          this.$session.set("COM_NAME", "");
          this.$session.set("EVENT_IDX", null);
          this.$session.set("EVENT_NAME", "");
          this.loadpage(1);
      },

      priceToString(price) {
        return price.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',');
      },

      //행사 유료/무료 변경시
      change_costtype(select){
        if(select == 0){
          //무료면 가격을 강제로 변경한다.
          this.editedItem.COST = 0;
        }
      },

    },
  
}
</script>


<style lang="css">
  td{
    height: 36px !important;
  }
</style>

<!-- scoped가 있으면 해당 컴포넌트에서만 스타일이 반영됨 -->
<style scoped>
  
  .v-input--selection-controls{
    margin-top:0px;
  }

</style>